<template>
     <div class="test-view">
        <v-card class="mx-auto normal-card instructions-hg">
            <CommonInstructionsContent />
        </v-card>
        <div class="test-bottom">
            <div class="bottom-logo">
                <!-- <img src="/img/logo-footer.c1b83f14.png" class="master-logo-btm" /> -->
            </div>
            <div class="test-btn-block bottom-btn-box">
                <v-btn
                    color="primary"
                    class="right-btn cust-btn back-btn-blue"
                    @click="goBack()"
                >Cancel</v-btn>
                <v-btn
                    v-if="isShowNext"
                    color="primary"
                    class="right-btn cust-btn next-btn-blue rg-btn"
                   @click="showTestInstructions()"
                >Next</v-btn>
                <v-btn
                    v-else
                    color="primary"
                    class="right-btn cust-btn next-btn-blue rg-btn"
                   @click="enterFullScreen()"
                >{{customText}}</v-btn>
            </div>
        </div>
    </div>
</template>

<script>
import CommonInstructionsContent from "@/components/student/Tests/CommonInstructionsContent.vue";
import { mapState } from "vuex";

export default {
    components: {
        CommonInstructionsContent
    },
    name: "TestDashboard",
    data: () => ({
        customText: "Start Answering",
        isShowNext: false
    }),
    props:['instructions','testData'],
    computed: {
        ...mapState("userStore", ["user"]),
    },
    watch:{
        instructions(){
            if(this.roleIds.ST === this.user.role_id  && this.instructions) {
                this.isShowNext = true
            }    
        }
    },
    mounted(){
        if (
            this.roleIds.CO === this.user.role_id ||
            this.roleIds.ID === this.user.role_id || 
			this.roleIds.ED === this.user.role_id ||
			this.roleIds.TR === this.user.role_id 
        ) {
            if (this.testData&& this.testData.test_type == this.TEST_TYPE.CUSTOM) {
                this.showEditButton = true;
            }
            
            this.isShowNext = true
        }
        if(this.roleIds.ST === this.user.role_id  && this.instructions) {
            this.isShowNext = true
        }
    },
    methods: {
        goBack() {
            let previousPath=localStorage.getItem("previousPath");
            if(previousPath){
            this.$router.replace({
                path: previousPath
            });
            localStorage.removeItem("previousPath");
            }else{
                this.$router.back();
            }
        },
        showTestInstructions() {
            localStorage.removeItem("previousPath");
            this.$parent.showCommonInstructions = false;
        },
        enterFullScreen() {
            const elem = document.documentElement; // Get the root element of the document
            if (elem.requestFullscreen) {
                elem.requestFullscreen();
            } else if (elem.mozRequestFullScreen) {
                elem.mozRequestFullScreen();
            } else if (elem.webkitRequestFullscreen) {
                elem.webkitRequestFullscreen();
            } else if (elem.msRequestFullscreen) {
                elem.msRequestFullscreen();
            } else if (elem.webkitEnterFullscreen) {
                elem.webkitEnterFullscreen(); // For iOS Safari
            } else if (elem.webkitEnterFullScreen) {
                elem.webkitEnterFullScreen(); // For older versions of iOS Safari
            }
        
            this.goToTest();
        },
        goToTest() {
            let testId = this.$route.params.test_id;
            let route = "test";
            let params = {
                test_id: testId,
                test_institute_id: this.$route.params.test_institute_id,
            };
			const prevRoute = localStorage.getItem('previousRoute')
			 if (
				this.roleIds.TR === this.user.role_id && prevRoute === 'past-tests' 
            ) {
                route = "past-tests-preview";
            } 
            else if (
                this.roleIds.CO === this.user.role_id ||
                this.roleIds.ID === this.user.role_id  || 
				this.roleIds.ED === this.user.role_id || 
				this.roleIds.TR === this.user.role_id 
            ) {
                route = "preview-test";
            } else if(this.testData && this.testData.test_schedule_id){
                params.test_schedule_id = this.testData.test_schedule_id;
                params.student_id = this.user.id;
            }
            
            this.$router.replace({
                name: route,
                params: params,
            });
        },
    },
    
};
</script>
